import type { CustomInclusion } from '@confluence/user-and-group-search';

export const useAccessClassInclusion = (): CustomInclusion => {
	// TODO (RBAC-1780): Implement query that gets access class names from the backend and replace with hardcoded names
	return [
		{
			allconfluenceusers: {
				id: 'all-licensed-users',
				name: 'All Confluence Users',
				type: 'custom',
				avatarUrl: require('./images/atlassian-icon.svg'),
			},
			allconfluenceadmins: {
				id: 'all-product-admins',
				name: 'All Confluence Admins',
				type: 'custom',
				avatarUrl: require('./images/atlassian-icon.svg'),
			},
		},
	];
};
